import React from "react";
import Box from "@mui/material/Box";

export default function Progress({ step, steps = 3 }) {
  const segmentWidth = 100 / steps;
  return (
    <Box position="relative">
      <Box
        position="absolute"
        ml={`${segmentWidth * step}%`}
        width={`${segmentWidth}%`}
        borderTop="2px solid"
        borderColor="#1976d2"
      />
      <Box borderTop="2px solid #d5d5d5" />
    </Box>
  );
}
